"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const merge_1 = require("merge");
const isObject = (thing) => (0, merge_1.isPlainObject)(thing);
exports.default = isObject;
